export class ComboPrograma {
	id: number;
	nome: string;
}